export const generateIDBStores = (stores: string[]) =>
  stores.reduce((store, key) => {
    store[key] = '++';
    return store;
  }, {} as { [key: string]: string });
